import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/add-image.svg'
import _imports_1 from '@/assets/img/icon/additional-prams-icon.svg'


const _hoisted_1 = {
  class: "flex w-full justify-between items-center pb-5",
  style: {"border-bottom":"1px solid #CFD8DC"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Pembayaran Komisi Kurir Manual", -1)
const _hoisted_3 = { class: " grid grid-cols-3 gap-4 " }
const _hoisted_4 = { class: " col-span-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-2 color-blue-grey" }, "Alasan Pembayaran Manual", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: " text-xs mb-2 color-blue-grey" }, " Bukti Pembayaran ", -1)
const _hoisted_7 = { class: "grid grid-cols-1" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: " w-full container-add-prams background-grey-lighten-5 p-5 cursor-pointer"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-center mb-2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: " w-8 h-8"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold text-center text-sm leading-5" }, " Drop the files here ... ", -1)
const _hoisted_12 = {
  key: 1,
  class: " h-full"
}
const _hoisted_13 = {
  key: 0,
  class: "container-file-upload rounded-lg cursor-pointer flex h-16"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "inline-flex gap-2 mx-auto items-center" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-upload color-blue-grey font-bold" }),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey font-semibold" }, "Upload Foto")
], -1)
const _hoisted_15 = {
  key: 1,
  class: "relative"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times text-white w-4 h-4" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-semibold text-sm" }, " Dengan ini pembayaran komisi kurir sudah selesai dilakukan dan status pembayaran akan menjadi “terbayar secara Manual” ")
], -1)
const _hoisted_18 = { class: "flex gap-4 justify-start" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Bayarkan")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isShowModal,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowModal = $event)),
    dismissableMask: true,
    modal: true,
    style: { width: '50vw' },
    onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideDialog())),
    class: "dialog-confirm"
  }, {
    header: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("i", {
          class: "pi pi-times text-black cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_Button, {
          class: "btn-red font-semibold px-10 text-white",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit()))
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          class: "btn-secondary text-black font-semibold px-10 py-1",
          type: "button",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideDialog()))
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode("section", null, [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Textarea, {
                placeholder: "Tulis Alasan (Wajib)",
                class: "input-grey w-full rounded-lg",
                modelValue: _ctx.reason,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.reason = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createVNode("div", null, [
              _hoisted_6,
              (_ctx.$store.state.device.isMobile)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    class: "list-photo",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCamera()))
                  }, [
                    _createVNode("div", _hoisted_7, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: 'image-' + index,
                          class: "relative mb-3"
                        }, [
                          (item.src === null)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                class: "w-full",
                                src: _imports_0,
                                alt: item.name
                              }, null, 8, ["alt"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                class: "w-full object-cover md:h-28 lg:h-20 h-36 rounded-lg",
                                src: item.src,
                                alt: item.name
                              }, null, 8, ["src", "alt"]))
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", _mergeProps({ class: "" }, _ctx.getRootProps()), [
                      _createVNode("input", _ctx.getInputProps(), null, 16),
                      (_ctx.isDragActive)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _hoisted_10,
                            _hoisted_11
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_12, [
                            _createVNode("div", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: 'image-' + index,
                                  class: "relative mb-3"
                                }, [
                                  (item.src === null)
                                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                        _hoisted_14
                                      ]))
                                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                                        (item.src !== null)
                                          ? (_openBlock(), _createBlock("div", {
                                              key: 0,
                                              class: "flex items-center rounded-full bg-red-500 absolute p-1 cursor-pointer",
                                              style: {"right":"0","top":"0","z-index":"10"},
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetImage()))
                                            }, [
                                              _hoisted_16
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode("img", {
                                          class: "w-full object-cover rounded-lg",
                                          src: item.src,
                                          alt: item.name
                                        }, null, 8, ["src", "alt"])
                                      ]))
                                ]))
                              }), 128))
                            ])
                          ]))
                    ], 16)
                  ]))
            ])
          ]),
          _hoisted_17
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}